module.exports = __webpack_public_path__ + "static/media/logo.be482a2a.png";